/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Demo_Sub_ResearchInputs */

const en_funnel_ob_demo_sub_research = /** @type {(inputs: Funnel_Ob_Demo_Sub_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a voice and press play. It reads the argument and skips the citations.`)
};

const es_funnel_ob_demo_sub_research = /** @type {(inputs: Funnel_Ob_Demo_Sub_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una voz y dale a reproducir. Lee el argumento y omite las citas.`)
};

/**
* | output |
* | --- |
* | "Pick a voice and press play. It reads the argument and skips the citations." |
*
* @param {Funnel_Ob_Demo_Sub_ResearchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_demo_sub_research = /** @type {((inputs?: Funnel_Ob_Demo_Sub_ResearchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Demo_Sub_ResearchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_demo_sub_research(inputs)
	return en_funnel_ob_demo_sub_research(inputs)
});